const destinations = [
  {
    name: "Italy",
    context: "Amalfi Coast villas, Tuscany agriturismo, Rome city breaks",
    urgency: "Last-minute villa rentals often book 2–4 weeks out",
    icon: "ri-map-pin-2-line",
    flag: "IT",
  },
  {
    name: "France",
    context: "Provence wine tours, Paris fashion weeks, Riviera yachting",
    urgency: "Charter guests often confirm 10–14 days before departure",
    icon: "ri-map-pin-2-line",
    flag: "FR",
  },
  {
    name: "United Kingdom",
    context: "London business, Scottish golf trips, Cotswolds getaways",
    urgency: "Executive travel frequently has 7–10 day lead time",
    icon: "ri-map-pin-2-line",
    flag: "GB",
  },
  {
    name: "Caribbean Islands",
    context: "St. Barts, Anguilla, Antigua, and Bahamas private island charters",
    urgency: "Yacht charters and villa bookings happen on short notice",
    icon: "ri-map-pin-2-line",
    flag: "BS",
  },
  {
    name: "Greek Islands",
    context: "Mykonos, Santorini, and yacht itineraries through the Cyclades",
    urgency: "Mediterranean cruising season creates late passport needs",
    icon: "ri-map-pin-2-line",
    flag: "GR",
  },
  {
    name: "Canada",
    context: "Summer lake homes, Toronto business, Montreal culture",
    urgency: "Snowbirds often realize expiration mid-season switch",
    icon: "ri-map-pin-2-line",
    flag: "CA",
  },
];

const commonSituations = [
  {
    stat: "72%",
    label: "of Naples expedited requests are renewals discovered within 2 weeks of travel",
  },
  {
    stat: "3–6 Weeks",
    label: "average notice Naples travelers have before a planned international trip",
  },
  {
    stat: "Nov–Jan",
    label: "peak season when snowbirds discover passport issues upon Florida arrival",
  },
  {
    stat: "48 Hours",
    label: "shortest charter departure we have accommodated for an APF private flight",
  },
];

export default function NaplesDestinationsSection() {
  return (
    <section className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Local Travel Intelligence</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Where Naples Travelers Go — And Why Passports Get Urgent
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            These are the destinations and travel patterns we see most from Southwest Florida clients. Understanding local travel behavior is part of why our document review catches issues before they derail your trip.
          </p>
        </div>

        {/* Stat block row */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-14">
          {commonSituations.map((s, i) => (
            <div key={i} className="bg-[#1A365D] rounded-lg p-6 text-center">
              <p className="font-serif text-3xl font-bold text-[#F6C344] mb-2">{s.stat}</p>
              <p className="text-white/60 text-xs leading-relaxed">{s.label}</p>
            </div>
          ))}
        </div>

        {/* Destinations grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mb-12">
          {destinations.map((d, i) => (
            <div key={i} className="bg-[#F7F8FA] rounded-lg p-6 border border-gray-200 hover:border-[#F6C344] transition-all group">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#1A365D]/5 group-hover:bg-[#F6C344]/15 transition-colors flex-shrink-0">
                  <i className={`${d.icon} text-[#1A365D] group-hover:text-[#F6C344] transition-colors text-lg`}></i>
                </div>
                <div>
                  <h3 className="font-bold text-[#1A365D] text-sm">{d.name}</h3>
                </div>
              </div>
              <p className="text-gray-500 text-sm leading-relaxed mb-3">
                {d.context}
              </p>
              <div className="flex items-start gap-2">
                <i className="ri-time-line text-[#F6C344] text-xs flex-shrink-0 mt-0.5"></i>
                <p className="text-gray-400 text-xs leading-relaxed italic">
                  {d.urgency}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Internal linking block */}
        <div className="bg-[#F7F8FA] rounded-lg p-6 border border-gray-200">
          <div className="flex flex-col md:flex-row items-start md:items-center gap-4">
            <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#1A365D]/5 flex-shrink-0">
              <i className="ri-links-line text-[#1A365D] text-xl"></i>
            </div>
            <div className="flex-1">
              <h3 className="font-bold text-[#1A365D] text-sm mb-1">Explore Other Florida Service Areas</h3>
              <p className="text-gray-500 text-sm leading-relaxed">
                We serve travelers across Southwest and Southeast Florida with the same expedited passport processing and document review expertise. Looking for service in another community?
              </p>
            </div>
            <div className="flex flex-wrap gap-2 flex-shrink-0">
              <a href="/cities/tampa" className="inline-flex items-center gap-1.5 bg-white hover:bg-[#1A365D] text-[#1A365D] hover:text-white border border-gray-200 hover:border-[#1A365D] font-medium text-xs px-3.5 py-2 rounded-md transition-all whitespace-nowrap">
                Tampa <i className="ri-arrow-right-line text-xs"></i>
              </a>
              <a href="/cities/orlando" className="inline-flex items-center gap-1.5 bg-white hover:bg-[#1A365D] text-[#1A365D] hover:text-white border border-gray-200 hover:border-[#1A365D] font-medium text-xs px-3.5 py-2 rounded-md transition-all whitespace-nowrap">
                Orlando <i className="ri-arrow-right-line text-xs"></i>
              </a>
              <a href="/cities/boca-raton" className="inline-flex items-center gap-1.5 bg-white hover:bg-[#1A365D] text-[#1A365D] hover:text-white border border-gray-200 hover:border-[#1A365D] font-medium text-xs px-3.5 py-2 rounded-md transition-all whitespace-nowrap">
                Boca Raton <i className="ri-arrow-right-line text-xs"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}